/* esm.sh - applesauce-core@5.2.0/dist/helpers/hidden-tags */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/hidden-tags.mjs";
